module.exports = __webpack_public_path__ + "img/1528578378.1a7d59cd.jpg";